import { matchPath, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { routes, pathKey } from "pages/routes";

const { CAMPAIGN, BRIEFING_FORM, UNAUTHORIZED } = pathKey;
const blacklistedRoutes = [CAMPAIGN, BRIEFING_FORM, UNAUTHORIZED];

export const useAdminPanel = () => {
    const location = useLocation();
    const [isPanelVisible, setPanelVisible] = useState(false);

    useEffect(() => {
        const currentRoute = routes.find((route) => matchPath(location.pathname, route));
        const isBlacklisted = blacklistedRoutes.some((route) => route === currentRoute?.key);

        if (isBlacklisted) {
            setPanelVisible(false);

            return;
        }

        setPanelVisible(true);
    }, [location.pathname]);

    return isPanelVisible;
};
